export default __webpack_public_path__ + "static/media/rhese.728ddab8.svg";